(() => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;
  const images = JSON.parse(document.getElementById('pdp-data').textContent);
  if (!images.length) return;
  const main = document.getElementById('pdp-image');
  const mainLink = document.querySelector('[data-gallery-open]');
  const thumbnails = [...gallery.querySelectorAll('[data-gallery-index]')];
  const thumbnailViewport = gallery.querySelector('.pdp-thumbnails');
  const mobileThumbnails = window.matchMedia('(max-width: 760px)');
  function revealThumbnail(index) {
    if (!thumbnailViewport || thumbnails.length <= (mobileThumbnails.matches ? 4 : 8)) return;
    const box = thumbnailViewport.getBoundingClientRect();
    const thumb = thumbnails[index].getBoundingClientRect();
    if (mobileThumbnails.matches) {
      if (thumb.left < box.left + 2) thumbnailViewport.scrollLeft += thumb.left - box.left - 2;
      else if (thumb.right > box.right - 2) thumbnailViewport.scrollLeft += thumb.right - box.right + 2;
      return;
    }
    if (thumb.top < box.top + 2) thumbnailViewport.scrollTop += thumb.top - box.top - 2;
    else if (thumb.bottom > box.bottom - 2) thumbnailViewport.scrollTop += thumb.bottom - box.bottom + 2;
  }
  if (thumbnailViewport && thumbnails.length > 4) {
    let previousWidth = -1, previousMobile = null;
    const sizeThumbnails = () => {
      const width = thumbnailViewport.clientWidth;
      const mobile = mobileThumbnails.matches;
      if (!width || (width === previousWidth && mobile === previousMobile)) return;
      previousWidth = width;
      previousMobile = mobile;
      thumbnailViewport.classList.toggle('pdp-thumbnails-scroll', thumbnails.length > (mobile ? 4 : 8));
      if (mobile) {
        thumbnailViewport.style.maxHeight = '';
        thumbnailViewport.scrollTop = 0;
        revealThumbnail(current);
        return;
      }
      thumbnailViewport.scrollLeft = 0;
      if (thumbnails.length <= 8) {
        thumbnailViewport.style.maxHeight = '';
        thumbnailViewport.scrollTop = 0;
        return;
      }
      const first = thumbnails[0].getBoundingClientRect();
      const eighth = thumbnails[7].getBoundingClientRect();
      thumbnailViewport.style.maxHeight = `${Math.ceil(eighth.bottom - first.top + 4)}px`;
      revealThumbnail(current);
    };
    thumbnailViewport.addEventListener('focusin', event => {
      const index = thumbnails.indexOf(event.target.closest('[data-gallery-index]'));
      if (index >= 0) revealThumbnail(index);
    });
    mobileThumbnails.addEventListener('change', sizeThumbnails);
    requestAnimationFrame(sizeThumbnails);
    if (typeof ResizeObserver === 'function') new ResizeObserver(sizeThumbnails).observe(thumbnailViewport);
    else window.addEventListener('resize', sizeThumbnails);
  }
  const status = gallery.querySelector('[role="status"]');
  const dialog = document.querySelector('.pdp-lightbox');
  const viewport = dialog.querySelector('.pdp-lightbox-viewport');
  const expanded = dialog.querySelector('[data-lightbox-image]');
  const zoom = dialog.querySelector('[data-lightbox-zoom]');
  let current = 0, requested = 0, generation = 0, returnFocus = null, touch = null;
  const isZoomed = () => zoom.getAttribute('aria-pressed') === 'true';
  const announce = (message, error = false) => { status.textContent = message; status.classList.toggle('pdp-visually-hidden',!error); };
  function setZoom(active) {
    zoom.setAttribute('aria-pressed',String(active)); zoom.textContent = active ? 'Zoom out' : 'Zoom in';
    viewport.classList.toggle('is-zoomed',active); viewport.scrollTop = 0; viewport.scrollLeft = 0;
  }
  const productTitleVariation = document.querySelector('[data-product-title-variation]')?.textContent.trim() || document.querySelector('#pdp-title')?.textContent.trim() || '';
  function syncExpanded() {
    const image=images[current]; expanded.src=image.src; expanded.alt=image.alt;
    expanded.width=image.width; expanded.height=image.height;
    dialog.querySelector('[data-lightbox-counter]').textContent=`${current+1} / ${images.length}`;
    dialog.querySelector('[data-lightbox-caption]').textContent=productTitleVariation+(image.caption && !productTitleVariation.includes(image.caption)?' — '+image.caption:'');
    setZoom(false);
  }
  async function select(index, focusThumbnail = false) {
    index = (index + images.length) % images.length; requested = index;
    const token = ++generation;
    if (index === current) { gallery.removeAttribute('aria-busy'); announce(''); revealThumbnail(index); return; }
    const image = images[index]; gallery.setAttribute('aria-busy','true');
    const probe = new Image();
    try {
      await new Promise((resolve,reject) => { probe.onload=resolve; probe.onerror=reject; probe.src=image.src; });
      if (probe.decode) await probe.decode();
      if (token !== generation) return;
      main.src=image.src; main.removeAttribute('srcset'); main.alt=image.alt; main.width=image.width; main.height=image.height;
      mainLink.href=image.src; mainLink.setAttribute('aria-label',`Enlarge photo ${index+1}: ${image.alt}`);
      current=index;
      thumbnails.forEach((a,i) => { if (i===index) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); });
      gallery.querySelector('[data-gallery-counter]').textContent=`${index+1} / ${images.length}`;
      syncExpanded();
      revealThumbnail(index);
      announce(`Photo ${index+1} of ${images.length}: ${image.caption}`);
      if (focusThumbnail) thumbnails[index].focus({preventScroll:true});
    } catch {
      if (token !== generation) return;
      requested=current;
      announce('This photo could not load. Please try again or choose another photo.',true);
    } finally { if (token===generation) gallery.removeAttribute('aria-busy'); }
  }
  function handleKeys(event) {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    let index;
    if (event.key==='ArrowRight') index=requested+1;
    else if(event.key==='ArrowLeft') index=requested-1;
    else if(event.key==='Home') index=0;
    else if(event.key==='End') index=images.length-1;
    else return;
    event.preventDefault();
    select(index,event.target.matches('[data-gallery-index]'));
  }
  function open(event) {
    if (event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey || (event?.button && event.button !== 0)) return;
    if (typeof dialog.showModal !== 'function') return;
    event?.preventDefault(); returnFocus=document.activeElement; syncExpanded();
    dialog.showModal(); dialog.querySelector('[data-lightbox-close]').focus();
  }
  function close() { dialog.close(); }
  thumbnails.forEach((a,i) => a.addEventListener('click',event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
    event.preventDefault(); select(i);
  }));
  gallery.addEventListener('keydown',handleKeys);
  mainLink.addEventListener('click',open);
  const expand = gallery.querySelector('[data-gallery-expand]');
  if (typeof dialog.showModal === 'function') { expand.hidden=false; expand.addEventListener('click',open); }
  gallery.querySelector('.pdp-photo-controls').hidden=false;
  gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>select(requested-1));
  gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>select(requested+1));
  dialog.querySelector('[data-lightbox-prev]').addEventListener('click',()=>select(requested-1));
  dialog.querySelector('[data-lightbox-next]').addEventListener('click',()=>select(requested+1));
  dialog.querySelector('[data-lightbox-close]').addEventListener('click',close);
  zoom.addEventListener('click',()=>{ const active=!isZoomed(); setZoom(active); if(active)viewport.focus({preventScroll:true}); });
  dialog.addEventListener('keydown',event => { if (!isZoomed() || event.target !== viewport) handleKeys(event); });
  dialog.addEventListener('close',()=>{ setZoom(false); returnFocus?.focus({preventScroll:true}); });
  dialog.addEventListener('click',event=>{ if(event.target!==dialog)return; const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close(); });
  // Horizontal single-touch gestures select photos; vertical scroll and pinch stay native.
  const stage=gallery.querySelector('.pdp-gallery-stage');
  stage.addEventListener('touchstart',event=>{ touch=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null; },{passive:true});
  stage.addEventListener('touchmove',event=>{ if(event.touches.length!==1)touch=null; },{passive:true});
  stage.addEventListener('touchcancel',()=>{touch=null;},{passive:true});
  stage.addEventListener('touchend',event=>{ if(!touch||event.changedTouches.length!==1)return; const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y; touch=null; if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)select(requested+(dx<0?1:-1)); },{passive:true});
})();


(() => {
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  const normalize = value => clean(value).toLowerCase().replace(/[.:]+$/, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const fields = [
    ['brand', /^(brand|designer|manufacturer)$/, 10],
    ['model', /^(model|model name)$/, 20],
    ['style', /^(style|jewelry type|jewellery type|product type|type)$/, 25],
    ['metal', /^(metal|metal type|metal purity|material|materials)$/, 30],
    ['center stone', /^(center|centre|main) (stone|diamond|gemstone)s?$/, 35],
    ['stones', /^(diamonds?|stones?|gemstones?|diamond details|stone details)$/, 36],
    ['side stones', /^(side|accent) (stones?|diamonds?|gemstones?)$/, 37],
    ['case size', /^(case size|case dimensions|case diameter)$/, 40],
    ['ring size', /^(ring size)$/, 41],
    ['dimensions', /^(length|width|dimensions|size)$/, 42],
    ['bezel', /^(bezel)$/, 46],
    ['bezel color', /^(bezel colou?r)$/, 46],
    ['bezel type', /^(bezel type)$/, 46],
    ['crystal', /^(crystal)$/, 49],
    ['case back', /^(case back)$/, 49],
    ['hour markers', /^(hour markers|hour marks|indices)$/, 49],
    ['setting', /^(setting|setting style|setting type)$/, 51],
    ['color', /^(diamond colou?r|stone colou?r|colou?r)$/, 52],
    ['clarity', /^(diamond clarity|clarity)$/, 52],
    ['cut', /^(diamond cut|cut)$/, 52],
    ['polish', /^(polish)$/, 52],
    ['symmetry', /^(symmetry)$/, 52],
    ['fluorescence', /^(fluorescence)$/, 52],
    ['certification', /^(gia report|igi report|certificate|certification|grading report)$/, 53],
    ['included', /^(included|box certificate|box papers)$/, 54],
    ['dial', /^(dial|dial color|dial colour)$/, 45],
    ['bracelet', /^(bracelet|band material|bracelet material|bracelet strap|band strap)$/, 48],
    ['movement', /^(movement|movement type)$/, 50],
    ['condition', /^(condition)$/, 55],
    ['weight', /^(weight|total weight)$/, 60],
    ['stone weight', /^(carat weight|diamond weight|total carat weight|total diamond weight)$/, 61],
    ['shape', /^(stone shape|diamond shape|shape)$/, 65],
    ['reference', /^(reference|reference number|model number)$/, 70]
  ];
  const excluded = /\b(shipping|delivery|warranty|guarantee|authenticity|authentic|return policy|refund|financing|payment|add to cart|buy now|contact us|call us|water resistan\w*|serial number|discount|offer|sale price)\b|https?:\/\/|www\.|\b(?:sn\s*#|s\/n)\s*\S/i;
  const invalid = /^(n\/?a|none|unknown|not (available|specified|applicable)|[-–—])\.?$/i;
  const sameValue = value => clean(value).toLowerCase().replace(/[.;]+$/, '');
  const trimEnd = value => clean(value).replace(/[.:;]+$/, '');
  const getField = label => fields.find(field => field[1].test(normalize(label)));
  function groupFor(element, root) {
    let node = element;
    while (node && node !== root) {
      if (node.parentElement?.matches('ul,ol')) {
        const parent = node.parentElement.parentElement;
        if (parent?.matches('li')) {
          const clone = parent.cloneNode(true);
          clone.querySelectorAll('ul,ol').forEach(list => list.remove());
          const label = trimEnd(clone.textContent);
          if (label && label.length <= 70) return label;
        }
      }
      let previous = node.previousElementSibling;
      while (previous && !previous.matches('h1,h2,h3,h4,h5,h6')) previous = previous.previousElementSibling;
      if (previous) {
        const label = trimEnd(previous.textContent);
        if (/\b(center|centre|side|accent|main|pendant|chain|stone \d|diamond \d|ring \d|item \d)\b/i.test(label) && label.length <= 70) return label;
        return '';
      }
      node = node.parentElement;
    }
    return '';
  }
  const join = values => {
    values = values.filter(Boolean);
    return values.length < 3 ? values.join(' and ') : values.slice(0, -1).join(', ') + ', and ' + values.at(-1);
  };
  const sentence = text => text ? text.replace(/^./, letter => letter.toUpperCase()).replace(/[.;]+$/, '') + '.' : '';
  const prose = value => trimEnd(value)
    .replace(/\b(lab)[ -]grown\b/gi, 'lab-grown')
    .replace(/\b(white|yellow|rose|gold|silver|sterling|stainless|steel|platinum|natural|round|oval|pear|brilliant|diamond|diamonds|stone|stones|center|centre|side|accent|main|pendant|chain|shaped|black|blue|green|red|champagne|mechanical|automatic|excellent|good|fair|new|pre-owned|grams?|total|weight|stud|earrings|engagement|ring|solitaire|three-stone|two|four|six|polished|sapphire|solid|unidirectional|rotating|baton|indexes|cut|none)\b/gi, word => word.toLowerCase())
    .replace(/(\d)\s*[Cc]t\.?/g, '$1 carat').replace(/\b[Cc]t\.?/g, 'carat').replace(/(\d)\s*mm\b/gi, '$1 mm')
    .replace(/\s*·\s*/g, ', ');
  const article = value => /^(a |an |the |two |three |four |five |six |seven |eight |nine |ten |\d+(?:\.\d+)?\s+carats?\s+of )/i.test(value) || /\b(diamonds|stones|earrings)\b/i.test(value) ? value : (/^[aeiou]/i.test(value) || /^18(?:[Kk]\b|\b)/.test(value) ? 'an ' : 'a ') + value;
  function stonePhrase(value) {
    let text = prose(value).replace(/(\d)(carat)/g, '$1 $2');
    const total = text.match(/^(.+?)\s+(\d*\.?\d+)\s+carat\s+total weight$/i);
    if (total) return total[1] + ' totaling ' + total[2] + ' carats';
    const leading = text.match(/^(\d*\.?\d+)\s+carat\s+(.+)$/i);
    if (leading) return /\b(diamonds|stones|gemstones)\b/i.test(leading[2]) ? leading[1] + ' carats of ' + leading[2] : article(leading[1] + '-carat ' + leading[2]);
    return article(text);
  }
  function compose(facts, source) {
    const byGroup = new Map();
    facts.forEach(fact => {
      const key = /\b(center|centre|side|accent|main|pendant|chain|stone \d|diamond \d|ring \d|item \d)\b/i.test(fact.group) ? fact.group : '';
      if (!byGroup.has(key)) byGroup.set(key, []);
      byGroup.get(key).push(fact);
    });
    const sentences = [];
    const headings = [...source.querySelectorAll('h1,h2,h3')].map(node => clean(node.textContent));
    const ownership = new Set(headings.map(text => /^\(?\s*new\s*\)?[.!]?$/i.test(text) ? 'new' : text.match(/^\(?\s*(pre[- ]owned)\b/i)?.[1]?.toLowerCase().replace(' ', '-')).filter(Boolean));
    const groupEntries = [...byGroup.entries()].sort((a, b) => (a[0] ? 1 : 0) - (b[0] ? 1 : 0));
    groupEntries.forEach(([group, scoped]) => {
      const get = key => scoped.find(fact => fact.key === key)?.value || '';
      const val = key => {
        const value = prose(get(key));
        return /weight$/.test(key) ? value.replace(/(\d*\.?\d+)\s+carat\b/g, '$1 carats').replace(/ total weight$/i, ' in total') : value;
      };
      const brand = trimEnd(get('brand')).replace(/Co$/, 'Co.');
      const model = trimEnd(get('model'));
      const style = val('style');
      const isWatch = !!(get('case size') || get('dial') || get('movement') || /watch/i.test(style));
      const isStoneGroup = /\b(center|centre|side|accent|main|stone \d|diamond \d)\b/i.test(group);
      const plural = /\b(earrings|stones|diamonds)\b/i.test(group || style);
      const noun = group ? prose(group).replace(/\s+specifications?$/i, '') : style || (isWatch ? 'watch' : get('ring size') ? 'ring' : 'piece');
      let subject = group ? 'The ' + noun : (plural ? 'These ' : 'This ') + [brand, model, noun !== 'watch' || !model ? noun : ''].filter(Boolean).join(' ');
      const it = group ? 'The ' + noun : plural ? 'They' : 'It';
      const has = plural ? 'have' : 'has';
      const is = plural ? 'are' : 'is';
      const metal = val('metal');
      const reference = trimEnd(get('reference'));
      if (reference) subject += ' (reference ' + reference + ')';
      if (isWatch) {
        const details = [];
        if (get('case size')) details.push(article(val('case size') + ' case'));
        if (get('dial')) details.push(article(val('dial') + ' dial'));
        const bezel = val('bezel') || [val('bezel color'), val('bezel type')].filter(Boolean).join(' ');
        if (bezel) details.push(article(bezel + ' bezel'));
        if (metal && !get('bracelet')) subject += ' in ' + metal;
        const movement = val('movement');
        const first = details.length ? subject + ' ' + has + ' ' + join(details) : subject + (metal ? ' ' + is + ' made from ' + metal : ' ' + is + ' described in the listing');
        sentences.push(sentence(first));
        const features = [];
        if (movement) features.push(article(movement + ' movement'));
        if (get('bracelet')) features.push(article(val('bracelet').replace(/\s*\/\s*/g, ' and ') + (/\b(bracelet|strap|band)\b/i.test(get('bracelet')) ? '' : ' bracelet')));
        if (get('crystal')) features.push(article(val('crystal') + ' crystal'));
        if (get('case back')) features.push(article(val('case back') + ' case back'));
        if (get('hour markers')) features.push(val('hour markers').replace(/\s*\/\s*/g, ' and ').replace(/\s*(indexes|indices|hour markers)$/i, '') + ' hour markers');
        if (features.length) sentences.push(sentence(it + ' ' + has + ' ' + join(features)));
      } else {
        const stones = [];
        if (get('center stone')) stones.push(stonePhrase(get('center stone')) + ' at the center');
        if (get('stones')) stones.push(stonePhrase(get('stones')));
        if (get('side stones')) stones.push(stonePhrase(get('side stones')) + ' as side stones');
        const features = [];
        if (get('shape')) features.push(plural ? val('shape') + ' shapes' : article(val('shape') + ' shape'));
        if (get('setting')) features.push(article(val('setting') + (/setting/i.test(get('setting')) ? '' : ' setting')));
        if (stones.length) sentences.push(sentence(subject + (metal ? ' in ' + metal : '') + (plural ? ' feature ' : ' features ') + join(stones) + (features.length ? ', with ' + join(features) : '')));
        else if (metal || features.length || isStoneGroup) {
          let text = subject;
          if (metal) text += ' ' + is + ' made from ' + metal;
          if (features.length) text += (metal ? ' and ' : ' ') + has + ' ' + join(features);
          if (isStoneGroup && get('weight')) text += (metal || features.length ? ' and ' : ' ') + (plural ? 'weigh ' : 'weighs ') + val('weight');
          if (text !== subject) sentences.push(sentence(text));
        }
      }
      const measures = [];
      if (get('ring size')) measures.push((plural ? 'are' : 'is') + ' a U.S. size ' + val('ring size').replace(/\s*U\.?S\.?$/i, ''));
      scoped.filter(fact => fact.key.startsWith('dimension:')).forEach(fact => {
        const dimension = normalize(fact.label);
        measures.push('measures ' + prose(fact.value) + (dimension === 'length' ? ' in length' : dimension === 'width' ? ' in width' : ''));
      });
      if (get('weight') && !isStoneGroup) measures.push((plural ? 'weigh' : 'weighs') + ' ' + val('weight'));
      if (get('stone weight') && /\b(ct|carats?|ctw|cttw|tcw)\.?\b/i.test(get('stone weight'))) {
        const label = scoped.find(fact => fact.key === 'stone weight').label.toLowerCase();
        measures.push(has + ' a ' + label + ' of ' + val('stone weight'));
      }
      const condition = val('condition').replace(/\s+condition$/i, '');
      const conditionOwnership = condition.match(/\b(pre[- ]owned|new)\b/i)?.[1]?.toLowerCase().replace(' ', '-');
      const owner = !group && ownership.size === 1 && (!conditionOwnership || ownership.has(conditionOwnership)) ? [...ownership][0] : '';
      let conditionText = condition;
      if (owner && !conditionOwnership) conditionText = owner + (condition ? ', ' + condition : '');
      const state = conditionText.split(/,\s*/);
      if (state.length === 2 && /^(pre-owned|new)$/i.test(state[0])) measures.push(is + ' ' + state[0] + ' and in ' + state[1] + ' condition');
      else if (conditionText) measures.push(/^(pre-owned|new)$/i.test(conditionText) ? is + ' ' + conditionText : is + ' in ' + conditionText + ' condition');
      if (measures.length) sentences.push(sentence(it + ' ' + join(measures)));
      const grades = [];
      if (get('color')) grades.push(trimEnd(get('color')) + ' color');
      if (get('clarity')) grades.push(trimEnd(get('clarity')) + ' clarity');
      for (const key of ['cut','polish','symmetry']) if (get(key)) grades.push(val(key) + ' ' + key);
      if (get('fluorescence')) grades.push(/^none\.?$/i.test(get('fluorescence')) ? 'no fluorescence' : val('fluorescence') + ' fluorescence');
      const certification = scoped.find(fact => fact.key === 'certification');
      const report = certification ? (/report/i.test(certification.label) ? certification.label + ' ' : '') + trimEnd(certification.value) : '';
      if (grades.length) sentences.push(sentence((group ? 'The ' + noun + (plural ? ' have ' : ' has ') : 'The listed diamond grading is ') + join(grades) + (report ? ', with ' + report : '')));
      else if (report) sentences.push(sentence((group ? 'The ' + noun + (plural ? ' have ' : ' has ') : 'The listing includes ') + report));
      if (get('included')) sentences.push(sentence((group ? 'The ' + noun + (plural ? ' come' : ' comes') : plural ? 'They come' : 'It comes') + ' with ' + article(trimEnd(get('included')).replace(/\bBox\b/g, 'box').replace(/\s*\/\s*/g, ' and a '))));
    });
    return sentences.join(' ');
  }
  function summarize(details) {
    const target = details.querySelector('[data-product-summary]');
    if (!target || target.dataset.ready === 'true') return;
    const output = target.querySelector('[data-product-summary-content]');
    if (!output) return;
    const source = details.cloneNode(true);
    source.querySelectorAll('summary,[data-product-summary],script,style,template,noscript,iframe,svg,button,form,[hidden],[aria-hidden="true"]').forEach(node => node.remove());
    source.querySelectorAll('[style]').forEach(node => {
      if (/(display\s*:\s*none|visibility\s*:\s*hidden)/i.test(node.getAttribute('style'))) node.remove();
    });
    const candidates = [];
    function add(label, value, element) {
      label = trimEnd(label);
      value = clean(value);
      const field = getField(label);
      if (!field || !value || value.length > 190 || (invalid.test(value) && !(field[0] === 'fluorescence' && /^none\.?$/i.test(value))) || (excluded.test(label + ' ' + value) && !(field[0] === 'included' && !/\b(guarantee|warranty|shipping|payment|serial number)\b/i.test(value)))) return;
      if (/:\s*\S/.test(value)) return;
      let group = groupFor(element, source);
      if (!group && ['color','clarity','cut','polish','symmetry','fluorescence'].includes(field[0])) {
        let previous = element.previousElementSibling;
        while (previous) {
          const previousLabel = clean(previous.textContent).match(/^([^:]{2,45}):/)?.[1];
          const previousField = previousLabel && getField(previousLabel);
          if (previousField && ['center stone','side stones','stones'].includes(previousField[0])) {
            group = trimEnd(previousLabel);
            break;
          }
          if (!previousField || !['color','clarity','cut','polish','symmetry','fluorescence'].includes(previousField[0])) break;
          previous = previous.previousElementSibling;
        }
      }
      if (!group && field[0] === 'certification') {
        const reportText = [...source.querySelectorAll('p')].map(node => clean(node.textContent)).find(text => /center diamond is accompanied by/i.test(text) && text.split(/[^A-Za-z0-9]+/).includes(trimEnd(value)));
        if (reportText) group = 'Center Diamond';
      }
      if (excluded.test(group) || (field[0] === 'color' && !group && /^colou?r$/i.test(label))) return;
      candidates.push({label, value, key:field[0] === 'dimensions' ? 'dimension:' + normalize(label) : field[0], rank:field[2], group});
    }
    source.querySelectorAll('dt').forEach(dt => {
      if (dt.nextElementSibling?.matches('dd')) add(dt.textContent, dt.nextElementSibling.textContent, dt);
    });
    source.querySelectorAll('tr').forEach(row => {
      const cells = [...row.children].filter(cell => cell.matches('th,td'));
      if (cells.length === 2) add(cells[0].textContent, cells[1].textContent, row);
    });
    source.querySelectorAll('li,p,div').forEach(element => {
      if (element.querySelector('ul,ol,dl,table,li,p,div,h1,h2,h3,h4,h5,h6') || element.closest('td,th,dd,dt')) return;
      const text = clean(element.textContent);
      const match = text.match(/^([^:]{2,45}):\s*(.+)$/);
      if (match) add(match[1], match[2], element);
      else {
        const label = clean(element.querySelector('strong,b')?.textContent);
        if (label && getField(label) && text.startsWith(label)) add(label, text.slice(label.length), element);
      }
    });
    const narrative = [...source.querySelectorAll('p')].map(node => clean(node.textContent)).filter(text => !excluded.test(text) && !/\b(not|without|could|can|optional)\b/i.test(text)).join(' ');
    const settingMatches = [...narrative.matchAll(/\b(?:the|its)(?: classic)? ((?:three|four|five|six|eight|\d+)-prong) setting\b/gi)].map(match => match[1]);
    if (!candidates.some(fact => fact.key === 'setting') && new Set(settingMatches.map(normalize)).size === 1) candidates.push({label:'Setting',value:settingMatches[0],key:'setting',rank:51,group:''});
    if (!candidates.some(fact => fact.key === 'style') && candidates.some(fact => fact.key === 'ring size') && !candidates.some(fact => ['side stones','stones'].includes(fact.key)) && /\bsolitaire ring\b/i.test(narrative)) candidates.push({label:'Style',value:'Solitaire Ring',key:'style',rank:25,group:''});
    const buckets = new Map();
    candidates.forEach(fact => {
      const key = fact.key + '|' + normalize(fact.group);
      const existing = buckets.get(key);
      if (!existing) buckets.set(key, fact);
      else if (sameValue(existing.value) !== sameValue(fact.value)) existing.conflict = true;
    });
    const facts = [...buckets.values()].filter(fact => !fact.conflict);
    const groupsByKey = new Map();
    facts.forEach(fact => {
      if (!groupsByKey.has(fact.key)) groupsByKey.set(fact.key, new Set());
      groupsByKey.get(fact.key).add(normalize(fact.group));
    });
    const selected = facts.filter(fact => {
      if (groupsByKey.get(fact.key).size > 1 && !fact.group) return false;
      if (fact.key === 'bracelet' && facts.some(other => other.key === 'metal' && other.group === fact.group && sameValue(other.value) === sameValue(fact.value))) return false;
      if (fact.key === 'style' && /^(wristwatch|watch|jewel[lr]y)\.?$/i.test(fact.value) && facts.some(other => other.key === 'model')) return false;
      return true;
    })
      .sort((a,b) => a.rank - b.rank);
    const composed = selected.length ? compose(selected, source) : '';
    if (composed) {
      const paragraph = document.createElement('p');
      paragraph.textContent = composed;
      output.replaceChildren(paragraph);
    } else {
      const excerpt = [...source.querySelectorAll('p,h1,h2')].map(node => clean(node.textContent))
        .find(text => text.length >= 25 && text.length <= 260 && !excluded.test(text) && !/:\s*\S/.test(text));
      if (excerpt) {
        const paragraph = document.createElement('p');
        paragraph.textContent = excerpt;
        output.replaceChildren(paragraph);
      }
    }
    target.dataset.ready = 'true';
  }
  function initialize(root) {
    if (root.matches?.('.pdp-primary-details')) summarize(root);
    root.querySelectorAll('.pdp-primary-details').forEach(summarize);
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


(() => {
  const sidebar = document.querySelector('.pdp-sidebar');
  if (!sidebar) return;
  const mobile = window.matchMedia('(max-width: 760px)');
  let disclosure = null;
  function setup() {
    if (!mobile.matches) {
      if (!disclosure) return;
      const {details, summary, panel, heading, help} = disclosure;
      const focused = document.activeElement === summary;
      sidebar.replaceChildren(...panel.childNodes);
      help.prepend(heading);
      sidebar.classList.remove('pdp-help-collapsible');
      if (focused) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
        heading.removeAttribute('tabindex');
      }
      disclosure = null;
      return;
    }
    if (disclosure) return;
    const help = sidebar.querySelector('.pdp-sidebar-help');
    const heading = help?.querySelector('h2');
    if (!heading) return;
    const details = document.createElement('details');
    details.className = 'pdp-description pdp-help-disclosure';
    const summary = document.createElement('summary');
    summary.id = heading.id;
    summary.textContent = heading.textContent;
    summary.setAttribute('aria-expanded', 'false');
    summary.setAttribute('aria-controls', 'pdp-help-all-content');
    const panel = document.createElement('div');
    panel.id = 'pdp-help-all-content';
    heading.remove();
    panel.append(...sidebar.childNodes);
    details.append(summary, panel);
    sidebar.append(details);
    sidebar.classList.add('pdp-help-collapsible');
    details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    details.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
      summary.focus();
    });
    disclosure = {details, summary, panel, heading, help};
  }
  mobile.addEventListener('change', setup);
  setup();
})();
